import { string } from "prop-types";

import withLabel from "web/Components/Common/withLabel";

import classes from "./new.scss";

const ProductCardTitleLabelNew = ({ label }) => {
  return (
    label && (
      <span className={classes.root} data-t2={label} data-t1="title_label_new">
        {label}
      </span>
    )
  );
};

ProductCardTitleLabelNew.propTypes = {
  label: string,
};

ProductCardTitleLabelNew.defaultProps = {
  label: "",
};

export default withLabel(ProductCardTitleLabelNew);
